// src/components/OrderDetails.js
import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const OrderDetails = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOrderDetails = useCallback(async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(`http://localhost:8000/api/orders/${orderId}/`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setOrder(response.data);
    } catch (err) {
      console.error('Error fetching order details:', err);
    } finally {
      setLoading(false);
    }
  }, [orderId]); // Add orderId as dependency

  useEffect(() => {
    fetchOrderDetails();
  }, [fetchOrderDetails]); // Now fetchOrderDetails is stable

  if (loading) return <div className="p-4">Loading order details...</div>;
  if (!order) return <div className="p-4 text-red-500">Order not found</div>;

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Order Details #{order.id}</h2>
      
      <div className="bg-white rounded-lg shadow-md p-6 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <h3 className="font-semibold text-lg mb-2">Order Information</h3>
            <p className="mb-1"><span className="font-medium">Date:</span> {new Date(order.created_at).toLocaleString()}</p>
            <p className="mb-1"><span className="font-medium">Status:</span> <span className="font-semibold capitalize">{order.status}</span></p>
            <p className="mb-1"><span className="font-medium">Payment Method:</span> {order.payment_method}</p>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-2">Total Amount</h3>
            <p className="text-2xl font-bold text-green-600">₹{order.total_price}</p>
          </div>
        </div>

        <h3 className="font-semibold text-lg mb-3">Order Items</h3>
        <div className="border rounded-lg divide-y">
          {order.items?.map((item, index) => (
            <div key={index} className="p-4 flex justify-between items-center">
              <div className="flex-1">
                <p className="font-medium text-gray-900">{item.product?.name || 'Product'}</p>
                <p className="text-sm text-gray-600">Quantity: {item.quantity}</p>
              </div>
              <div className="text-right">
                <p className="font-medium">₹{item.price}</p>
                <p className="text-sm text-gray-600">Total: ₹{(item.price * item.quantity).toFixed(2)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;